
import PropTypes from "prop-types";
import { createContext, useEffect, useMemo, useState } from "react";
import { checkLoginStatus } from "../API/res"; // wrapper around /api/checklogin/

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const fetchLoginStatus = async () => {
      const storedUser = localStorage.getItem("user");
      const storedAuth = localStorage.getItem("isAuthenticated");

      if (storedUser && storedAuth === "true") {
        setUser(JSON.parse(storedUser));
        setIsAuthenticated(true);
        setLoading(false);
      } else {
        try {
          const data = await checkLoginStatus(); // fallback to API
          if (data) {
            const userData = {
              username: data.username || data.name || (data.email && data.email.split("@")[0]) || "",
              name: data.name,
              email: data.email,
            };
            setUser(userData);
            setIsAuthenticated(true);
            localStorage.setItem("user", JSON.stringify(userData));
            localStorage.setItem("isAuthenticated", "true");
          } else {
            setUser(null);
            setIsAuthenticated(false);
          }
        } catch (error) {
          console.error("Error checking login status:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchLoginStatus();
  }, []);

  const contextValue = useMemo(() => ({
    user,
    setUser,
    isAuthenticated,
    setIsAuthenticated,
    loading,
  }), [user, isAuthenticated, loading]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
